module.exports = __webpack_public_path__ + "static/Mainframe_SablierBannerNoText-7f572b5836deecd391c4a314994856ee.svg";